(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/game-guide-tipsen/assets/javascripts/tipsen-menu.js') >= 0) return;  svs.modules.push('/components/tipsen/game-guide-tipsen/assets/javascripts/tipsen-menu.js');
"use strict";

const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem;
const _svs$components$tipse = svs.components.tipsen.gameGuideTipsen.constants,
  menuItemsQs = _svs$components$tipse.menuItemsQs,
  queryParam = _svs$components$tipse.queryParam;
const getDisplayName = svs.components.lbUtils.sportProducts.getDisplayName;
const useDefinition = svs.components.tipsen.engine.utils.useDefinition;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const useBranding = svs.components.tipsen.hooks.useBranding;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const lotteryProducts = ['Stryktipset', 'Europatipset', 'Powerplay', 'Topptipset', 'Fullträff'];
const systemProducts = ['Stryktipset', 'Europatipset', 'Powerplay', 'Topptipset', 'Bomben'];
const TipsenMenuLink = _ref => {
  let label = _ref.label,
    queryString = _ref.queryString;
  const history = useHistory();
  const qs = new URLSearchParams(history.location.search);
  const currentQs = new URLSearchParams(history.location.search);
  qs.set(queryParam, queryString);
  return React.createElement(LinkItem, {
    Component: TipsenLink,
    label: label,
    selected: currentQs.get(queryParam) === queryString || !currentQs.get(queryParam) && queryString === menuItemsQs.play,
    to: "/spelguide?".concat(qs.toString())
  });
};
const TipsenMenu = _ref2 => {
  var _useDefinition$drawPr, _useDefinition;
  let hasArticleIdSystem = _ref2.hasArticleIdSystem,
    hasArticleIdLottery = _ref2.hasArticleIdLottery;
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const classNames = "items-menu-wrapper-side-nav ".concat(branding);
  const productId = (_useDefinition$drawPr = (_useDefinition = useDefinition()) === null || _useDefinition === void 0 || (_useDefinition = _useDefinition.drawProductIds) === null || _useDefinition === void 0 ? void 0 : _useDefinition[0]) !== null && _useDefinition$drawPr !== void 0 ? _useDefinition$drawPr : undefined;
  const productName = getDisplayName(productId);
  const shouldShowLottery = lotteryProducts.includes(productName) && hasArticleIdLottery;
  const shouldShowSystem = systemProducts.includes(productName) && hasArticleIdSystem;
  return React.createElement(ItemsMenu, {
    ariaLabel: "Information om ".concat(productName),
    className: classNames,
    hiddenScrollbar: true
  }, React.createElement(TipsenMenuLink, {
    label: "S\xE5 spelar du",
    queryString: menuItemsQs.play
  }), React.createElement(TipsenMenuLink, {
    label: "Om ".concat(productName),
    queryString: menuItemsQs.about
  }), shouldShowSystem && React.createElement(TipsenMenuLink, {
    label: productName === 'Bomben' ? 'Systemreducering' : 'Systemspel',
    queryString: menuItemsQs.system
  }), shouldShowLottery && React.createElement(TipsenMenuLink, {
    label: "Lottning",
    queryString: menuItemsQs.lottery
  }));
};
setGlobal('svs.components.tipsen.gameGuideTipsen.TipsenMenu', TipsenMenu);

 })(window);